<template>
  <div class="talent-page">
    <div class="banner" v-if="deviceType == 'pc'"><div class="w"></div></div>
    <img src="../../assets/images/home/xwzx.png" alt="" v-else />
    <div v-if="deviceType == 'pc'">
      <div class="w">
        <div class="detail-local">
          当前位置：<span @click="clicktrain" style="cursor: pointer"
            >教育培训</span
          >
        </div>
      </div>
      <div class="w">
        <div class="news">
          <!-- 这是后台编辑的页面 -->
          <div id="newsReview">
            <div class="title">{{ datelist.title }}</div>
            <div class="date">{{ datelist.createTime }}</div>
            <div class="desc">
              <p v-html="datelist.content"></p>
              <!-- <p style="text-indent: 43px; line-height: 2em">
                {{ datelist.content }}
              </p> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="trainbox">
        <div>
          <div class="detail-local">
            当前位置：<span @click="clicktrain">教育培训</span>
          </div>
        </div>
        <div>
          <div class="news">
            <!-- 这是后台编辑的页面 -->
            <div id="newsReview">
              <div class="title">{{ datelist.title }}</div>
              <div class="date">{{ datelist.createTime }}</div>
              <div class="desc">
                <p v-html="datelist.content"></p>
                <!-- <p style="text-indent: 43px; line-height: 2em">
                  {{ datelist.content }}
                </p> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <blockSidebar />
  </div>
</template>
<script>
import(
  `@/assets/css/${
    navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    )
      ? 'mobile'
      : 'pc'
  }/talent.scss`
)
import blockSidebar from '@/components/block-sidebar'
export default {
  // 人力资源
  components: { blockSidebar },
  data() {
    return {
      datelist: {},
      ids: '',
    }
  },
  computed: {
    deviceType() {
      return this.$store.state.app.deviceType
    },
  },
  created() {
    // this.datelist = JSON.parse(this.$route.query.param)
    // console.log(this.datelist)
    this.ids = this.$route.query.id
    if (this.ids) {
      this.getArticleDetail(this.ids)
      // this.changeBackgroundImage(this.ids)
    } else {
      this.$router.push('/talent')
    }
  },
  methods: {
    getArticleDetail(id) {
      this.$api.product.getArticleDetail(id).then((res) => {
        if (res.code === 200) {
          this.datelist = res.data
        }
      })
    },
    clicktrain() {
      this.$router.push('/talent/education')
    },
  },
}
</script>
<style scoped lang="scss">
.banner {
  background: url(~@/assets/images/home/banner-news.gif) no-repeat center;
}
</style>
